export enum AgentInputMode {
  None = 'none',
  ExperimentalMode = 'experimentalMode',
  DeepDiveMode = 'deepDiveMode',
  BuildMode = 'buildMode',
  MultiOrgMode = 'multiOrgMode',
}

